export const FETCH_TARIFF_BY_ORGANIZATION = 'FETCH_TARIFF_BY_ORGANIZATION'
export const CREATE_TARIFF_BY_ORGANIZATION = 'CREATE_TARIFF_BY_ORGANIZATION'
export const UPDATE_TARIFF_BY_ORGANIZATION = 'UPDATE_TARIFF_BY_ORGANIZATION'
export const DELETE_TARIFF_BY_ORGANIZATION = 'DELETE_TARIFF_BY_ORGANIZATION'
